<template>
  <div class="edit-profile-page">
    <div class="edit-profile-container bg-white radius-20 padding-30">
      <!-- 头部 -->
      <div class="edit-header flex align-center margin-bottom-30">
        <i class="el-icon-arrow-left back-icon" @click="handleBack"></i>
        <span class="header-title text-000-color text-bold">个人中心</span>
      </div>

      <!-- 表单内容 -->
      <div class="form-content radius-20 padding-30" v-loading="loadingUserInfo">
        <h3 class="form-title text-000-color text-bold margin-bottom-30">个人资料</h3>
        <!-- 头像上传 -->
        <div class="form-section margin-bottom-30 padding-top-15">
          <div class="form-item flex align-center">
            <label class="form-label text-000-color">头像</label>
            <div class="avatar-upload-wrapper">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="handleAvatarChange"
                :before-upload="beforeAvatarUpload"
                accept="image/*">
                <img v-if="avatarPreview" :src="avatarPreview" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="avatar-tips text-12 text-999-color margin-top-10">
                支持 JPG、PNG 格式，大小不超过 2MB
              </div>
            </div>
          </div>
        </div>
        <!-- 个人资料 -->
        <div class="form-section margin-bottom-30 padding-top-15">
          <div class="form-item flex align-center margin-bottom-20">
            <label class="form-label text-000-color">手机号</label>
            <el-input v-model="formData.phone" placeholder="输入手机号" class="form-input"></el-input>
          </div>
          <div class="form-item flex align-center">
            <label class="form-label text-000-color">邮箱</label>
            <el-input v-model="formData.email" placeholder="输入邮箱" class="form-input"></el-input>
          </div>
        </div>

        <!-- 微信信息 -->
        <div class="form-section margin-bottom-30">
          <h3 class="section-title text-000-color text-bold margin-bottom-20">微信信息</h3>
          <div class="form-item flex align-center margin-bottom-20 ">
            <label class="form-label text-000-color">用户名</label>
            <el-input v-model="formData.wechatUsername" placeholder="请输入" class="form-input"></el-input>
          </div>
          <div class="form-item flex align-center">
            <label class="form-label text-000-color">微信号</label>
            <el-input v-model="formData.wechatId" placeholder="请输入" class="form-input"></el-input>
          </div>
        </div>

        <!-- 支付宝信息 -->
        <div class="form-section margin-bottom-30">
          <h3 class="section-title text-000-color text-bold margin-bottom-20">支付宝信息</h3>
          <div class="form-item flex align-center margin-bottom-20">
            <label class="form-label text-000-color">用户名</label>
            <el-input v-model="formData.alipayUsername" placeholder="请输入" class="form-input"></el-input>
          </div>
          <div class="form-item flex align-center">
            <label class="form-label text-000-color">支付宝号</label>
            <el-input v-model="formData.alipayAccount" placeholder="请输入" class="form-input"></el-input>
          </div>
        </div>

        <!-- 银行卡信息 -->
        <div class="form-section margin-bottom-30">
          <h3 class="section-title text-000-color text-bold margin-bottom-20">银行卡信息</h3>
          <div class="form-item flex align-center margin-bottom-20">
            <label class="form-label text-000-color">开户行</label>
            <el-input v-model="formData.bankName" placeholder="请输入" class="form-input"></el-input>
          </div>
          <div class="form-item flex align-center margin-bottom-20">
            <label class="form-label text-000-color">开户支行</label>
            <el-input v-model="formData.bankBranch" placeholder="请输入" class="form-input"></el-input>
          </div>
          <div class="form-item flex align-center">
            <label class="form-label text-000-color">银行卡号</label>
            <el-input v-model="formData.bankCard" placeholder="请输入" class="form-input"></el-input>
          </div>
        </div>

        <!-- 确定按钮 -->
        <div class="form-footer flex justify-center">
          <el-button class="confirm-btn" :loading="loading" @click="handleConfirm">
            {{ loading ? '保存中...' : '确定' }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateProfile, getUserInfo } from '@/api/user';
import { uploadFile } from '@/api/common';

export default {
  name: 'EditProfile',
  data() {
    return {
      loading: false,
      loadingUserInfo: false,
      avatarPreview: '', // 头像预览
      avatarFile: null, // 头像文件对象
      avatarUrl: '', // 头像URL（用于提交）
      formData: {
        phone: '',
        email: '',
        wechatUsername: '',
        wechatId: '',
        alipayUsername: '',
        alipayAccount: '',
        bankName: '',
        bankBranch: '',
        bankCard: ''
      }
    };
  },
  mounted() {
    this.loadUserInfo();
  },
  methods: {
    // 验证手机号格式
    validatePhone(phone) {
      const phoneReg = /^1[3-9]\d{9}$/;
      return phoneReg.test(phone);
    },
    // 验证邮箱格式
    validateEmail(email) {
      const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailReg.test(email);
    },
    // 从接口加载用户信息
    loadUserInfo() {
      // 先从 localStorage 获取基本信息作为默认值
      const savedUserInfo = localStorage.getItem('userInfo');
      if (savedUserInfo) {
        try {
          const info = JSON.parse(savedUserInfo);
          this.formData.phone = info.mobile || info.phone || '';
          this.formData.email = info.email || '';
        } catch (e) {
          console.error('解析用户信息失败:', e);
        }
      }

      // 调用接口获取完整的用户信息
      this.loadingUserInfo = true;
      getUserInfo()
        .then(response => {
          this.loadingUserInfo = false;
          if (response.data) {
            const data = response.data;
            // 填充基本信息
            this.formData.phone = data.mobile || data.phone || this.formData.phone;
            this.formData.email = data.email || this.formData.email;
            
            // 填充头像
            if (data.avatar) {
              this.avatarPreview = data.avatar;
              this.avatarUrl = data.avatar;
            } else {
              // 如果没有头像，使用默认头像
              this.avatarPreview = require('@/assets/images/login.png');
            }
            
            // 填充微信信息
            this.formData.wechatUsername = data.wechat_username || data.wechatUsername || '';
            this.formData.wechatId = data.wechat_no || data.wechatId || '';
            
            // 填充支付宝信息
            this.formData.alipayUsername = data.alipay_username || data.alipayUsername || '';
            this.formData.alipayAccount = data.alipay_account || data.alipayAccount || '';
            
            // 填充银行卡信息
            this.formData.bankName = data.bank_name || data.bankName || '';
            this.formData.bankBranch = data.bank_branch || data.bankBranch || '';
            this.formData.bankCard = data.bank_account || data.bankCard || '';
          }
        })
        .catch(error => {
          this.loadingUserInfo = false;
          console.error('获取用户信息失败:', error);
          // 如果接口失败，至少使用 localStorage 中的信息
          if (!this.formData.phone && !this.formData.email) {
            this.$message.warning('获取用户信息失败，请稍后重试');
          }
        });
    },
    handleBack() {
      this.$router.go(-1);
    },
    // 头像上传前的验证
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('头像大小不能超过 2MB!');
        return false;
      }
      return false; // 阻止自动上传，手动处理
    },
    // 处理头像选择
    handleAvatarChange(file, fileList) {
      if (file.raw) {
        // 创建预览
        const reader = new FileReader();
        reader.onload = (e) => {
          this.avatarPreview = e.target.result;
        };
        reader.readAsDataURL(file.raw);
        this.avatarFile = file.raw;
      }
    },
    // 上传头像
    uploadAvatar() {
      return new Promise((resolve, reject) => {
        if (!this.avatarFile) {
          // 如果没有新选择的头像文件，使用现有的头像URL
          resolve(this.avatarUrl);
          return;
        }

        const formData = new FormData();
        formData.append('file', this.avatarFile);
        
        uploadFile(formData)
          .then(response => {
            if (response.data) {
              const avatarUrl = response.data.url || response.data.fullurl || response.data;
              this.avatarUrl = avatarUrl;
              resolve(avatarUrl);
            } else {
              reject(new Error('上传失败'));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    handleConfirm() {
      // 表单验证
      if (this.formData.phone&&!this.validatePhone(this.formData.phone)) {
        this.$message.warning('请输入正确的手机号格式（11位数字，以1开头）');
        return;
      }
      if (this.formData.email&&!this.validateEmail(this.formData.email)) {
        this.$message.warning('请输入正确的邮箱格式');
        return;
      }
      // 先上传头像（如果有新头像）
      this.loading = true;
      this.uploadAvatar()
        .then(avatarUrl => {
          // 调用接口更新个人信息
          return updateProfile({
            mobile: this.formData.phone,
            email: this.formData.email,
            avatar: avatarUrl, // 添加头像字段
            wechat_username: this.formData.wechatUsername,
            wechat_no: this.formData.wechatId,
            alipay_username: this.formData.alipayUsername,
            alipay_account: this.formData.alipayAccount,
            bank_name: this.formData.bankName,
            bank_branch: this.formData.bankBranch,
            bank_account: this.formData.bankCard
          });
        })
        .then(response => {
          this.loading = false;
          this.$message.success('保存成功');
          // 更新本地存储的用户信息
          if (this.avatarUrl) {
            const savedUserInfo = localStorage.getItem('userInfo');
            if (savedUserInfo) {
              try {
                const userInfo = JSON.parse(savedUserInfo);
                userInfo.avatar = this.avatarUrl;
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                localStorage.setItem('userAvatar', this.avatarUrl);
              } catch (e) {
                console.error('更新本地用户信息失败:', e);
              }
            }
          }
          // 延迟返回，让用户看到成功提示
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        })
        .catch(error => {
          this.loading = false;
          this.$message.error(error.message || '保存失败，请稍后重试');
        });
    }
  }
};
</script>

<style scoped lang="scss">
.edit-profile-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff6f8 0%, #f3f7ff 100%);
  padding: 20px;
}

.edit-profile-container {
  max-width: 1200px;
  margin: 0 auto;
}

.edit-header {
  margin-bottom: 20px;

  .back-icon {
    font-size: 20px;
    color: #000;
    cursor: pointer;
    margin-right: 10px;
    transition: all 0.3s;

    &:hover {
      color: #D85A70;
      transform: translateX(-3px);
    }
  }

  .header-title {
    font-size: 18px;
  }
}



.form-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-title {
  font-size: 20px;
  margin: 0;
  width: 100%;
  max-width: 569px;
  text-align: left;
}

.form-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .section-title {
    font-size: 16px;
    margin: 0 0 15px 0;
    width: 100%;
    text-align: left;
    max-width: 569px;
  }
}

.form-item {
  margin-bottom: 20px;
  width: 100%;
  max-width: 569px;
  justify-content: flex-start;

  &:last-child {
    margin-bottom: 0;
  }
}

.form-label {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  text-align: left;
  margin-right: 20px;
}

  .form-input {
    width: 449px;

    ::v-deep .el-input__inner {
      border-radius: 8px;
      border: 1px solid #ebeef5;
      width: 449px;
      height: 50px;
      font-size: 14px;

      &:focus {
        border-color: #D85A70;
      }
    }
  }

  .avatar-upload-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .avatar-uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 8px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.3s;

      &:hover {
        border-color: #D85A70;
      }
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
    object-fit: cover;
    border-radius: 8px;
  }

  .avatar-tips {
    margin-top: 8px;
  }

.form-footer {
  margin-top: 40px;
  padding-top: 30px;
}

.confirm-btn {
  width: 345px;
  height: 46px;
  background: #D85A70;
  border-color: #D85A70;
  color: #fff;
  border-radius: 57px;
  font-size: 16px;

  &:hover {
    background: #c54a60;
    border-color: #c54a60;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .edit-profile-page {
    padding: 15px;
  }

  .form-label {
    width: 80px;
    font-size: 13px;
    margin-right: 15px;
  }

  .confirm-btn {
    width: 100%;
  }
}
</style>
